import React from 'react'

// Style sheet
import '../scss/aboutContent.scss';

// Page components
import TopNavbar from "../../components/pagecomponents/ts/topNavbar";
import Footer from "../../components/pagecomponents/ts/Footer";
import PageBanner from '../../components/pagecomponents/ts/pageBanner';

import AboutInformation from '../../components/aboutcomponents/ts/aboutInformation'
import WebsiteHistory from '../../components/aboutcomponents/ts/websiteHistory';
// END

function AboutContent() {

  return (
    <div>
        {/* Navbar */}
        <div>
          <TopNavbar />
        </div>

        <div>
          <PageBanner 
            title={"關於本站"} 
            description={"志在最優質的氣象"} 
            icon={"BsInfoCircle"} 
            id={"mainPageBanner"}
          />
        </div>

        <div className='' id=''>
          <AboutInformation />
        </div>

        <div className='' id=''>
          <WebsiteHistory />
        </div>
        
        <div>
          <Footer />
        </div>

    </div>
  )

}

export default AboutContent;